import type { App } from 'vue';

interface ErrorPayload {
    message: string;
    stack: string;
    url: string;
    user_id?: string | number;
    type?: string;
}

export default {
    init(app: App) {
        app.config.errorHandler = (err: unknown, instance: any, info: string) => {
            console.error('Vue errorHandler caught an error:', err, info);

            const payload: ErrorPayload = {
                message: err instanceof Error ? err.message : String(err),
                stack: err instanceof Error && err.stack ? err.stack : '',
                url: window.location.href,
                type: 'VueError - ' + info
            };

            // You can optionally grab the user ID from localStorage or a state manager here
            // const user = JSON.parse(localStorage.getItem('user') || '{}');
            // if (user && user.id) {
            //     payload.user_id = user.id;
            // }

            // Determine the API URL base. Example, if using VITE_API_URL
            const apiUrl = import.meta.env.VITE_API_URL || '/api';

            // Send to the backend endpoint
            fetch(`${apiUrl}/system/log-frontend`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            }).catch(e => {
                console.error('Failed to log frontend error to backend', e);
            });
        };
    }
};
